import Divider from 'lib/ui/Divider'
import { downloadPdfCss } from 'lib/ui/DownloadPdf'
import Heading from 'lib/ui/Heading'
import Text from 'lib/ui/Text'
import { formatDate } from 'utils/dates'
import { formatCurrency } from 'utils/numbers'

import TextHighlight from './TextHighlight'
export interface ITransactionPdf {
  amount: number
  totalAmount: number
  date: string
  invoiceNumber: string
  paymentMethod: string
  invoiceAmount?: number
  referenceId?: string
}

const TransactionPdfLayout = ({
  amount,
  invoiceAmount,
  totalAmount,
  date,
  invoiceNumber,
  paymentMethod,
  referenceId
}: ITransactionPdf) => (
  <>
    <div>
      <div css={{ ...downloadPdfCss.topRow }}>
        <div>
          <Text size='xs' color='grey25'>
            Paid on
          </Text>
          <TextHighlight>
            {formatDate(date, 'MMM DD, YYYY', 'partnerTimezone')}
          </TextHighlight>
        </div>
        {referenceId ? (
          <div>
            <Text size='xs' color='grey25'>
              Reference ID
            </Text>
            <TextHighlight>
              {referenceId.startsWith('#') ? referenceId : `#${referenceId}`}
            </TextHighlight>
          </div>
        ) : (
          <>
            <div>
              <Text size='xs' color='grey25'>
                Invoice #
              </Text>
              <TextHighlight>{invoiceNumber}</TextHighlight>
            </div>
            {invoiceAmount !== null && invoiceAmount !== undefined && (
              <div>
                <Text size='xs' color='grey25'>
                  Invoice Amount
                </Text>
                <TextHighlight>
                  {formatCurrency({ amount: invoiceAmount })}
                </TextHighlight>
              </div>
            )}
          </>
        )}
      </div>

      <div css={{ marginTop: '40px' }}>
        <TextHighlight>Payment details</TextHighlight>
        <Text color='grey25' size='xs' styles={{ margin: '10px 0 0' }}>
          {paymentMethod}
        </Text>
      </div>
    </div>
    <div css={{ marginTop: '200px' }}>
      <div css={{ display: 'flex', justifyContent: 'space-between' }}>
        <Text size='xs' color='grey25'>
          Gross amount
        </Text>
        <TextHighlight size='xs'>{formatCurrency({ amount })}</TextHighlight>
      </div>
      <Divider color='grey15' margin={0.5} />
      <div css={{ display: 'flex', justifyContent: 'space-between' }}>
        <Text size='xs' color='grey25'>
          Fees
        </Text>
        <TextHighlight size='xs'>
          {formatCurrency({ amount: totalAmount - amount })}
        </TextHighlight>
      </div>
      <Divider color='grey15' margin={0.5} />
      <div css={{ display: 'flex', justifyContent: 'space-between' }}>
        <TextHighlight>Total paid</TextHighlight>
        <Heading tag='h3' color='grey25' size='md'>
          {formatCurrency({ amount: totalAmount })}
        </Heading>
      </div>
    </div>
  </>
)

export default TransactionPdfLayout
